export default {
  parenthoodCreateLoading: null,
  parenthoodCreateErrors: null,
  coupleUpdateLoading: false,
  coupleCreateLoading: null,
  coupleCreateErrors: null,
};
